import { ApiCreateProduct, ApiDeleteProduct, ApiGetProductById, ApiGetProductList, ApiUpdateProduct } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function ProductService() {
    const { showFail } = useModal()

    const { fetch: apiGetProductList } = useFetch(ApiGetProductList)
    const { fetch: apiDeleteProduct } = useFetch(ApiDeleteProduct)
    const { fetch: apiGetProductById } = useFetch(ApiGetProductById)
    const { fetch: apiCreateProduct } = useFetch(ApiCreateProduct)
    const { fetch: apiUpdateProduct } = useFetch(ApiUpdateProduct)

    const fetchProductList = async(productName, brandId, status, pageSize, index) => {
        const res = await apiGetProductList({
            data: {
                productName, 
                brandId,
                status,
                pageSize,
                pageIndex: parseInt(index)
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteProduct = async(productId, status) => {
        const res = await apiDeleteProduct({
            data: {
                productId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchProductById = async(productId) => {
        const res = await apiGetProductById({
            data: {
                productId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateProduct = async(brandId, productCode, category, productName, description, price, priceAfterDiscount, discount, productPhotoFile) => {
        let data = new FormData()

        data.append('ProductCode', productCode)
        data.append('BrandId', brandId)
        data.append('categoryId', category)
        data.append('ProductName', productName)
        data.append('Description', description)
        data.append('Price', price)
        data.append('NettPrice', priceAfterDiscount)
        data.append('Discount', discount)
        data.append('Picture', productPhotoFile)

        const res = await apiCreateProduct({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateProduct = async(productId, productCode, brandId, category, productName, description, price, priceAfterDiscount, discount, productPhotoFile) => {
        let data = new FormData()

        data.append('ProductId', productId)
        data.append('ProductCode', productCode)
        data.append('BrandId', brandId)
        data.append('categoryId', category)
        data.append('ProductName', productName)
        data.append('Description', description)
        data.append('Price', price.replaceAll(',', ''))
        data.append('NettPrice', String(priceAfterDiscount).replaceAll(',', ''))
        data.append('Discount', discount)
        data.append('Picture', productPhotoFile)

        const res = await apiUpdateProduct({ 
            data,
            headers: {
                'Content-type': 'multipart/form-data'
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchProductList,
        fetchDeleteProduct,
        fetchProductById,
        fetchCreateProduct,
        fetchUpdateProduct
    }
}